module.exports = __webpack_public_path__ + "static/media/how_cs.356e2bfc.vtt";